import { useState } from 'react'
import ArpMediaGraphVisualizer from '../core/ArpMediaGraphVisualizer'
import Button from '../core/Button/Button'
import { Box } from '../core/Components'
import Input from '../core/Input'

const ArpMediaVisualizerPage = () => {
  const [typedContent, setTypedContent] = useState<string>(null)
  const [mediaIndex, setMediaIndex] = useState<number>(null)

  const onClick = (e) => {
    setMediaIndex(Number(typedContent))
  }

  return (
    <Box>
      <Input
        value={typedContent}
        onChange={(e) => setTypedContent(e.target.value)}
        placeholder="Arp Media Index"
      />
      <Button onClick={onClick}>VISUALIZE</Button>
      <Box css={{ width: '100vw', height: '100vh', border: '1px solid black' }}>
        {mediaIndex !== null && <ArpMediaGraphVisualizer arpMediaIndex={mediaIndex} />}
      </Box>
    </Box>
  )
}

export default ArpMediaVisualizerPage
